export class UserData {
    public Name!: string;
    public Email!: string;
    public Title!: string;
    public Department!: string;
    public EmailKey!: string;
    public NtLogin!: string;
    public Image!: any;
    public AccessToken!: any;
    public Country!: any;
    public OfficeLocation!: any;
    public SecurityroleDescription!:string;
    public SecurityroleID!:string;
}
